import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useTeam, { generateUrls } from '@hooks/useTeam'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: ReactNode,
  teamPayload: ReturnType<typeof useTeam>,
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    activeTabBarItemKey,
    teamPayload: {
      team,
    },
    children,
  } = props

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { selectedAgencyId } = useAgencySelector()
  const { editTeamUrl, teamsIndexUrl } = generateUrls(team, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  return (
    <>
      <Helmet>
        <title>Edit Team | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || teamsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation
        tabBarItems={generateTabBarItems(team, editTeamUrl)}
        title="Edit Team"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
